import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";

const GenericSelectFilter = ({
  options,
  selectedOption,
  setSelectedOption,
  name,
  isSearchable = true,
  placeholder,
}) => {
  // Add styling based on selection
  const containerClass = `timesheet_dropdown_wrapper ${
    !selectedOption ? "empty-selection" : "has-selection"
  }`;

  return (
    <div className={containerClass}>
      <SelectDropdown
        options={options?.length > 0 ? options : []}
        name={name}
        value={selectedOption}
        setSelectedOption={setSelectedOption}
        isDisable={false}
        isSearchable={isSearchable}
        preventKeyboardOpen={false}
        menuPortalTarget={document.body}
        placeholder={placeholder || `Select ${name}`}
        className="ticket-filter-select"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base, state) => ({
            ...base,
            minHeight: "50px",
            borderColor: selectedOption
              ? "#dc3545"
              : state.isFocused
              ? "#dc3545"
              : "#dee2e6",
            "&:hover": {
              borderColor: "#dc3545",
            },
            boxShadow: state.isFocused
              ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
              : "none",
            borderRadius: "5px",
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "2px 8px",
          }),
          placeholder: (base) => ({
            ...base,
            color: "#6c757d",
            fontSize: "14px",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#212529",
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? "#dc3545"
              : state.isFocused
              ? "rgba(220, 53, 69, 0.1)"
              : "white",
            color: state.isSelected ? "white" : "#212529",
            "&:hover": {
              backgroundColor: state.isSelected
                ? "#dc3545"
                : "rgba(220, 53, 69, 0.1)",
            },
          }),
        }}
      />
    </div>
  );
};

export default GenericSelectFilter;
